// Country → State/Region mapping for African countries
// Easily extendable: just add new country key with its regions array

const COUNTRIES_DATA = {
  "Nigeria": [
    "Abia", "Adamawa", "Akwa Ibom", "Anambra", "Bauchi", "Bayelsa", "Benue", "Borno",
    "Cross River", "Delta", "Ebonyi", "Edo", "Ekiti", "Enugu", "FCT Abuja", "Gombe",
    "Imo", "Jigawa", "Kaduna", "Kano", "Katsina", "Kebbi", "Kogi", "Kwara",
    "Lagos", "Nasarawa", "Niger", "Ogun", "Ondo", "Osun", "Oyo", "Plateau",
    "Rivers", "Sokoto", "Taraba", "Yobe", "Zamfara"
  ],
  "Ghana": [
    "Ahafo", "Ashanti", "Bono", "Bono East", "Central", "Eastern",
    "Greater Accra", "North East", "Northern", "Oti", "Savannah",
    "Upper East", "Upper West", "Volta", "Western", "Western North"
  ],
  "Kenya": [
    "Baringo", "Bomet", "Bungoma", "Busia", "Elgeyo-Marakwet", "Embu",
    "Garissa", "Homa Bay", "Isiolo", "Kajiado", "Kakamega", "Kericho",
    "Kiambu", "Kilifi", "Kirinyaga", "Kisii", "Kisumu", "Kitui",
    "Kwale", "Laikipia", "Lamu", "Machakos", "Makueni", "Mandera",
    "Marsabit", "Meru", "Migori", "Mombasa", "Murang'a", "Nairobi County",
    "Nakuru", "Nandi", "Narok", "Nyamira", "Nyandarua", "Nyeri",
    "Samburu", "Siaya", "Taita-Taveta", "Tana River", "Tharaka-Nithi",
    "Trans-Nzoia", "Turkana", "Uasin Gishu", "Vihiga", "Wajir", "West Pokot"
  ],
  "South Africa": [
    "Eastern Cape", "Free State", "Gauteng", "KwaZulu-Natal", "Limpopo",
    "Mpumalanga", "North West", "Northern Cape", "Western Cape"
  ],
  "Rwanda": [
    "Eastern Province", "Kigali", "Northern Province", "Southern Province", "Western Province"
  ],
  "Uganda": [
    "Central", "Eastern", "Kampala", "Northern", "Western"
  ],
  "Tanzania": [
    "Arusha", "Dar es Salaam", "Dodoma", "Geita", "Iringa", "Kagera",
    "Katavi", "Kigoma", "Kilimanjaro", "Lindi", "Manyara", "Mara",
    "Mbeya", "Morogoro", "Mtwara", "Mwanza", "Njombe", "Pemba North",
    "Pemba South", "Pwani", "Rukwa", "Ruvuma", "Shinyanga", "Simiyu",
    "Singida", "Songwe", "Tabora", "Tanga", "Zanzibar North",
    "Zanzibar South", "Zanzibar West"
  ]
};

const COUNTRIES = Object.keys(COUNTRIES_DATA);

const PROFESSIONS = [
  "Architect", "Structural Engineer", "Civil Engineer", "Mechanical Engineer",
  "Electrical Engineer", "Builder", "Quantity Surveyor", "Project Manager",
  "Construction Manager", "Site Engineer", "Building Technologist", "Supervisor",
  "Technician", "Foreman", "Draftsman", "CAD Designer", "BIM Specialist",
  "MEP Engineer", "HVAC Engineer", "Plumber", "Electrician",
  "Aluminum / Facade Specialist", "Interior Fit-out Specialist", "Finishing Contractor",
  "Other"
];

export { COUNTRIES_DATA, COUNTRIES, PROFESSIONS };
